import { PiniaVuePlugin } from 'pinia'
import VueMask from 'v-mask'
import { VueConstructor } from 'vue'
import { ValidationProvider } from 'vee-validate'

import AnalyticsPlugin from 'aven_shared/src/plugins/analytics'
import { sanitizeHtml } from 'aven_shared/src/plugins/safeHtml'

// Vue 2.7 registers plugins/components/directives on the global Vue constructor; on the
// Vue 3 migration this function takes the `app` instance instead and the body is otherwise
// unchanged. Mirrors aven/src/config/initPlugins.ts to keep the migration diff small.
export const initPlugins = (vue: VueConstructor) => {
    // we need to register this component globally so that we can use it in aven_shared templates
    vue.component('ValidationProvider', ValidationProvider)

    vue.use(VueMask, {
        // This allows us to use the 'X' character as a regular char.
        // https://github.com/probil/v-mask#default-placeholders
        placeholders: {
            X: null,
        },
    })

    vue.use(AnalyticsPlugin)

    vue.use(PiniaVuePlugin)

    // Resolves the $sanitizeHtml call the v-html compile hook emits (see vue.config.mjs).
    vue.prototype.$sanitizeHtml = sanitizeHtml

    vue.directive('keep-scroll-position', {
        bind: function (el) {
            el.addEventListener('scroll', function (event) {
                // @ts-ignore
                event.target.setAttribute('data-vue-keep-scroll-position', event.target.scrollLeft + '-' + event.target.scrollTop)
            })
        },
        inserted: function (el) {
            let i, len, pos, target
            const targets = el.querySelectorAll('[data-vue-keep-scroll-position]')
            if (targets.length > 0) {
                for (i = 0, len = targets.length; i < len; i++) {
                    target = targets[i]
                    // @ts-ignore
                    pos = target.getAttribute('data-vue-keep-scroll-position').split('-')
                    // @ts-ignore
                    target.scrollLeft = pos[0]
                    // @ts-ignore
                    target.scrollTop = pos[1]
                }
            } else {
                if (el.hasAttribute('data-vue-keep-scroll-position')) {
                    // @ts-ignore
                    pos = el.getAttribute('data-vue-keep-scroll-position').split('-')
                    // @ts-ignore
                    el.scrollLeft = pos[0]
                    // @ts-ignore
                    el.scrollTop = pos[1]
                }
            }
        },
    })
}
